module.exports = __webpack_public_path__ + "img/initialize.60476473.svg";